import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface UiPickerObjectData {
  message: string;
  data: {
    item: {
      label: string;
      uuid: string;
    };
  };
}

export function useUiPickerObject({
  type,
  uuid,
}: {
  type?: string;
  uuid?: string;
}) {
  const { keycloak } = useKeycloak();

  return useQuery(['ui-picker-object', type, uuid], {
    enabled: !!type && !!uuid,
    queryFn: async (): Promise<UiPickerObjectData> => {
      const body = {
        type,
        uuid,
      };

      const response = await fetch(
        `${
          import.meta.env.VITE_API_URL
        }/bundles/query_bundle/functions/picker_object_detail`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(body),
        }
      );

      return response.json();
    },
  });
}
